export const whitespaceRegex = /\s/;

export const alphanumericRegex = /^[a-zA-Z0-9]*$/;
